module.exports = __webpack_public_path__ + "img/icon.63559718.svg";